var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clinician-customize-measure"},[_c('single-measure',{attrs:{"custom-measure-id":_vm.measureId},on:{"customizationFinished":_vm.finish}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }